import type { FC } from "react";

import { AddCampaignButton } from "src/app/features/TerminalVersion/components/buttons/AddCampaignButton";
import { CheckAllAffectedButton } from "src/app/features/TerminalVersion/components/buttons/CheckAllAffectedButton";
import { TerminalVersionSearchForm } from "src/app/features/TerminalVersion/components/forms/TerminalVersionSearchForm";
import { TerminalVersionsTable } from "src/app/features/TerminalVersion/components/tables/TerminalVersionsTable";
import type { TerminalVersionEntity } from "src/app/features/TerminalVersion/types/TerminalVersionEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const TerminalVersionsPage: FC<NoneOwnProps> = () => {
    const table = <TerminalVersionsTable />;
    const searchForm = <TerminalVersionSearchForm />;
    const hasAccess = canAccess(ResourceName.TERMINAL_VERSIONS, "canRead");

    return (
        <PageLayout name="terminalVersions_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.terminalVersions" />
                    <ResourceManager<TerminalVersionEntity>
                        useDataGroup
                        dataMapperKey="terminalVersionsTableData"
                        resource={ResourceName.TERMINAL_VERSIONS}
                        table={table}
                        searchForm={searchForm}
                        customActions={[
                            {
                                action: <CheckAllAffectedButton />,
                                permission: "canRead",
                            },
                            {
                                action: <AddCampaignButton />,
                                permission: "canRead",
                            },
                        ]}
                        actions={[Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
